import { getBezierPath } from '@xyflow/react'

export function getWorkflowEdgePath({
  sourceX,
  sourceY,
  sourcePosition,
  targetX,
  targetY,
  targetPosition,
}) {
  if (targetX >= sourceX) {
    return getBezierPath({
      sourceX,
      sourceY,
      sourcePosition,
      targetX,
      targetY,
      targetPosition,
      curvature: 0.25,
    })
  }

  const labelX = (sourceX + targetX) / 2
  const loopY = Math.max(sourceY, targetY) + Math.max(120, Math.abs(sourceY - targetY) * 0.45)
  const controlOffset = Math.max(72, Math.abs(sourceX - targetX) * 0.25)
  const edgePath = [
    `M${sourceX},${sourceY}`,
    `C${sourceX + controlOffset},${sourceY} ${sourceX + controlOffset},${loopY} ${labelX},${loopY}`,
    `C${targetX - controlOffset},${loopY} ${targetX - controlOffset},${targetY} ${targetX},${targetY}`,
  ].join(' ')

  return [edgePath, labelX, loopY]
}

export function getAiDependencyEdgePath({
  sourceX,
  sourceY,
  sourcePosition,
  targetX,
  targetY,
  targetPosition,
}) {
  return getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    curvature: 0.32,
  })
}
